module.exports = __webpack_public_path__ + "img/icon-compliance.ca4d76af.svg";